import {Component, inject, OnInit, signal} from '@angular/core';
import {HomeMainComponent} from "./home-main/home-main.component";
import {HomeStartTradingComponent} from "./home-start-trading/home-start-trading.component";
import {HomeNewsComponent} from "./home-news/home-news.component";
import {HomeApplicationComponent} from "./home-application/home-application.component";
import {HomeCalculatorComponent} from "./home-calculator/home-calculator.component";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {DashboardService} from "../../services/api/dashboard.service";
import {TQrData} from "../../services/api-types/dashboard.types";
import {TNewsItem} from "../about-us/about.types";
import {NewsService} from "../../services/api/news.service";
import { HomeIphoneComponent } from './home-iphone/home-iphone.component';
import {HomeTelegramMiniAppComponent} from "./home-telegram-qr/home-telegram-mini-app.component";

@Component({
  selector: 'app-home',
  imports: [
    HomeMainComponent,
    HomeStartTradingComponent,
    HomeIphoneComponent,
    HomeNewsComponent,
    HomeApplicationComponent,
    HomeCalculatorComponent,
    MatProgressSpinner,
    HomeTelegramMiniAppComponent
  ],
  templateUrl: './home.component.html',
  styles: ``
})
export class HomeComponent implements OnInit {
  #dashboardService = inject(DashboardService);
  #newsService = inject(NewsService);

  loading = signal<boolean>(false);
  qrData = signal<TQrData>({qrApp1: '', qrApp2: '', qrWallet: ''});

  loadNews = signal<boolean>(false);
  newsList = signal<TNewsItem[]>([]);
  reqData = signal({
    paging: {
      page: 0,
      size: 10
    }
  });

  ngOnInit(): void {
    this.#getQrData().then(() => {
    });
    this.#getNews().then(() => {
    });
  }

  async #getNews(): Promise<void> {
    this.loadNews.set(true);

    try {
      const res = await this.#newsService.newsList(this.reqData());

      if (res && res.success) {
        const list: TNewsItem[] = [...res.result.data.items];
        if (list.length > 3) {
          const slicedNews = list.slice(0, 3);
          this.newsList.set(slicedNews);
        } else {
          this.newsList.set(list);
        }
      }
    } catch (err: any) {
      console.debug(err);
    } finally {
      this.loadNews.set(false);
    }
  }

  async #getQrData(): Promise<void> {
    this.loading.set(true);

    try {
      const res = await this.#dashboardService.getQrData();

      if (res && res.success) {
        this.qrData.set(res.result.data);
      }
    } catch (err: any) {
      console.log(err);
    } finally {
      this.loading.set(false);
    }
  }
}
